<template>
	<svg :width="width" :height="height" :color="color">
		<use :href="`/frontend/svg/icons.svg#icon-${name}`"></use>
	</svg>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	name: {
		type: String,
		required: true,
	},
	color: {
		type: String,
		required: false,
	},
	size: {
		type: Number,
		required: false,
		default: 16,
	},
});

const width = computed(() => props.size + 'px');
const height = computed(() => props.size + 'px');
</script>
